<template>
 
  <div class="container">
    <div class="sidebar">
      <div
        v-for="(step, index) in steps"
        :key="index"
        :class="{ 'active-step': currentStep === index }"
        @click="setCurrentStep(index)"
      >
        <i :class="step.icon"></i>
        {{ step.name }}
      </div>
    </div>

      <component :is="currentStepComponent" />


    </div><br>
    <div v-if="isMobile" class="mobile-navigation">
    <button @click="previousStep" :disabled="currentStep === 0">Back</button>
    <button @click="nextStep" :disabled="currentStep === steps.length - 1">Next</button>
  </div><br><br><br><br><br><br>
</template>

<script>
import { ref, computed } from 'vue';
import IntroductionPrivacy from '@/components/onboarding/1-IntroductionPrivacy.vue';
import CountryofResidence from './2-CountryofResidence.vue';
import MaritalStatus from './3a-MaritalStatus.vue';
import ClientGoals from '@/components/onboarding/3b-ClientGoals.vue';
import HasKids from './3c-KidsStatus.vue';
import HasPets from './3d-PetsStatus.vue';
import CashFlow from '@/components/onboarding/4-CashFlow.vue';
import HomeLife from '@/components/onboarding/5-HomeLife.vue';
import CarLife from '@/components/onboarding/6-CarLife.vue';
import CreditLife from '@/components/onboarding/7-CreditLife.vue';
import InvestmentsLife from '@/components/onboarding/8-InvestmentsLife.vue';
import RainyDay from '@/components/onboarding/9-RainyDay.vue';
import EmploymentLife from '@/components/onboarding/10-EmploymentLife.vue';
import OnboardingMessage from '@/components/onboarding/12-OnboardingMessage.vue';


export default {
  
  components: {
    IntroductionPrivacy,
    CountryofResidence,
    MaritalStatus,
    HasKids,
    HasPets,
    ClientGoals,
    CashFlow,
    HomeLife,
    CarLife,
    CreditLife,
    InvestmentsLife,
    RainyDay,
    EmploymentLife,
    OnboardingMessage,
 
  },
  setup() {
    const currentStep = ref(0);
    const steps = [
      { name: 'Introduction', icon: '' },
      { name: 'Residency', icon: 'icon-for-step-2' },
        { name: 'Relationship', icon: 'icon-for-step-3' },
        { name: 'Kids', icon: 'icon-for-step-4' },
        { name: 'Pets', icon: 'icon-for-step-5' },
        { name: 'Financial Goals', icon: 'icon-for-step-6' },
        { name: 'Cashflow', icon: 'icon-for-step-7' },
        { name: 'Living Situation', icon: 'icon-for-step-8' },
        { name: 'Car', icon: 'icon-for-step-9' },
        { name: 'Credit', icon: 'icon-for-step-10' },
        { name: 'Investments', icon: 'icon-for-step-11' },
        { name: 'Insurance', icon: 'icon-for-step-12' },
        { name: 'Employment', icon: 'icon-for-step-13' },
        { name: 'Review', icon: 'icon-for-step-14' },
      
    
  
      ];
  
      const currentStepComponent = computed(() => {
      const components = [
        IntroductionPrivacy,
        CountryofResidence,
        MaritalStatus,
        HasKids,
        HasPets,
        ClientGoals,
        CashFlow,
        HomeLife,
        CarLife,
        CreditLife,
        InvestmentsLife,
        RainyDay,
        EmploymentLife,
        OnboardingMessage,
        ];
      return components[currentStep.value];
    });
    const isMobile = ref(window.innerWidth < 768);

window.addEventListener('resize', () => {
  isMobile.value = window.innerWidth < 768;
});

function setCurrentStep(index) {
  currentStep.value = index;
}

function nextStep() {
  if (currentStep.value < steps.length - 1) {
    currentStep.value++;
    window.scrollTo(0, 0); // Scroll to top
  }
}

function previousStep() {
  if (currentStep.value > 0) {
    currentStep.value--;
    window.scrollTo(0, 0); // Scroll to top
  }
}

return {
  currentStep,
  steps,
  currentStepComponent,
  setCurrentStep,
  nextStep,
  previousStep,
  isMobile,
};
},
};
</script>



<style scoped>



  .main-container {
    background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}


.selected {
font-weight: bold;
}


.rounded-button:hover {
background-color: black; /* Button background color on hover */
}

.container {
  display: flex;
  flex-direction: row;
}

.sidebar {
  width: 200px;
  height: 100%;
  border-right: 1px solid #ccc;
  padding: 15px;
}

.sidebar div {
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
  background-color: #36454f;
  color: white;
}

.sidebar div.active-step {
  background-color: #4A148C;
  color: white;
}

.content {
  padding: 15px;
  flex-grow: 1;
}

.rounded-button {
background-color: black;
color: white;
border-radius: 25px;
padding: 10px 20px;
border: none;
cursor: pointer;
transition: background-color 0.3s ease;
}


.highlighted {
  background-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  margin: 5px 0;
}


.mobile-navigation button {
  background-color: #4A148C;
  align-items: center;
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

/* Adjustments for content below to not overlap with fixed top navigation */
.container {
  padding-top: 60px; /* Adjust based on the height of the navigation bar */
}

@media only screen and (max-width: 768px) {
.sidebar {
  height: 60px;
  width: 100%;
  bottom: 0;
  left: 0;
  flex-direction: row;
  position: fixed;
}
}
.mobile-nav-buttons {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.mobile-nav-buttons button {
  flex: 1; /* Make buttons expand to fill the space */
  margin: 5 10px; /* Add some space between buttons */
  padding: 10px;
  background-color: #4A148C;
  color: white;
  border: none;
  border-radius: 5px;
  align-items: center;
}

/* Ensure the navigation buttons are only visible on mobile */
@media (min-width: 768px) {
  .mobile-nav-buttons {
    display: none;
  }
}


</style>
